import {
  Target,
  LineChart,
  Zap,
  Globe2,
  type LucideIcon,
} from "lucide-react";

/** Static editorial content for the home page. Pure data — no JSX. */

export const LOGOS = [
  "Ahrefs",
  "Semrush",
  "Screaming Frog",
  "Surfer SEO",
  "Google Search Console",
  "Clarity",
  "GA4",
  "Looker Studio",
];

export const STEPS: { icon: LucideIcon; title: string; desc: string }[] = [
  { icon: Target, title: "Discover", desc: "Deep audit of site, competitors, SERPs, and AI citation footprint." },
  { icon: LineChart, title: "Strategize", desc: "A roadmap built around revenue — not vanity rankings." },
  { icon: Zap, title: "Execute", desc: "Technical fixes, content systems, links, and AEO/GEO assets." },
  { icon: Globe2, title: "Scale", desc: "Compounding visibility across Google and the AI engines." },
];

export const AUTHORITY = [
  "Technical SEO audits",
  "Search Console measurement",
  "Structured data checks",
  "English & Bengali content",
  "Local search planning",
  "Sourced practical guides",
];

export const HOME_FAQS = [
  { q: "What's the difference between SEO, AEO, and GEO?", a: "SEO optimizes for traditional search engines. AEO (Answer Engine Optimization) optimizes for being cited inside AI assistants like ChatGPT, Perplexity, and Gemini. GEO blends both with strong local signals so you win in maps and AI together." },
  { q: "How long until I see results?", a: "Technical wins land in 2–6 weeks. Meaningful ranking and traffic shifts typically appear between months 3 and 6, then compound from there." },
  { q: "Do you work with brands outside Bangladesh?", a: "Yes. I've worked with founders and agencies across the US, UK, Germany, Singapore, and Australia. I'm based in Rangpur but work fully remote." },
  { q: "What does pricing look like?", a: "Focused SEO retainers start from $1,500/mo. One-off audits start at $750. Larger growth programs are scoped per project after a discovery call." },
];